import styled from 'styled-components';
import { TextField } from '@dsny/dsny-component-library';
import theme from 'src/styles/theme';

export const PanelCard = styled.div`
  width: 460px;
  background: ${theme.colors.white};
  border-radius: 0 8px 8px 0;
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.2);
  overflow: hidden;
  border: 1px solid ${theme.colors.neutralW90};
`;

export const PanelTop = styled.div`
  padding: 12px;
`;

export const TextFieldWrapper = styled(TextField)`
  font-size: 14px;
`;

export const SearchWrapperStyles = {
  paddingRight: '0px',
  marginBottom: '0px',
};

export const SearchInputStyles = {
  height: '44px',
  borderRadius: '8px',
  color: theme.colors.neutralW40,
};

export const SearchTailingStyles = {
  display: 'flex',
  alignItems: 'center',
  paddingRight: '10px',
  marginTop: '2px',
};

export const CompanyList = styled.div`
  display: block;
  max-height: calc((54px + 1px) * 5.5 + 1px);
  overflow-y: auto;
  border-radius: 0 0 8px 0;
  scrollbar-width: thin;
  scrollbar-color: ${theme.colors.neutralW70} transparent;

  &::-webkit-scrollbar {
    width: 6px;
  }

  &::-webkit-scrollbar-track {
    background: transparent;
    margin: 8px 0;
  }

  &::-webkit-scrollbar-thumb {
    background: ${theme.colors.neutralW70};
    border-radius: 999px;
  }
`;

interface CompanyRowProps {
  $isSelected: boolean;
}

export const CompanyRow = styled.button<CompanyRowProps>`
  width: 100%;
  height: 54px;
  padding: 0 18px 0 20px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: none;
  background: ${({ $isSelected }) =>
    $isSelected ? theme.colors.mtr100 : theme.colors.white};
  cursor: pointer;

  &:hover {
    background: ${theme.colors.neutralW100};
  }
`;

export const CompanyName = styled.span`
  flex: 1;
  min-width: 0;
  font-size: 14px;
  line-height: 20px;
  color: ${theme.colors.neutralW20};
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: left;
  padding-right: 12px;
`;

export const ArrowWrapper = styled.span`
  width: 16px;
  height: 16px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const NoResultsRow = styled.div`
  height: 54px;
  padding: 0 20px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid ${theme.colors.neutralW90};
  color: ${theme.colors.neutralW40};
  font-size: 14px;
`;
